import "./App.css";
import Home from "./components/Home";

function App() {
  return (
    <div>
      {/* <LandingPage /> */}
      <Home />
    </div>
  );
}

export default App;
